import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ApiConstant} from '../../types';
import { API_TOKEN,  } from '../types';

const TRANSACTION_NAME = environment.elasticAPM.transactionName;

@Injectable()
export class SimulationParticipantService {
    simulationUrl = `${this.apiConstants.endpoint}/SimulationParticipant`;
    participantUrl = `${environment.api.endpoint}/Participant`;

    private getBySimulationIdSub$ = new Subject<any>();

    constructor(
        @Inject(API_TOKEN) private apiConstants: ApiConstant,
        private httpClient: HttpClient,
    ) {}

    getBySimulationId(simulationId: any): Observable<any> {
        const headers = new HttpHeaders({ [TRANSACTION_NAME]: 'Get participant by simulationId' });
        return this.httpClient
            .post(`${this.simulationUrl}/GetBySimulationId`,simulationId, {
                headers
            })
            .pipe(
                tap(result => {
                    if (result) {
                        this.getBySimulationIdSub$.next(result);
                    }
                })
            );
    }

    getParticipantsOnline(simulationId: any): Observable<any> {
        const headers = new HttpHeaders({ [TRANSACTION_NAME]: 'Get participant online' });
        return this.httpClient
            .post(`${this.participantUrl}/GetParticipantsOnline`,{
                simulationId: simulationId,
            }, {
                headers
            })
            .pipe(
                tap(result => {
                    if (result) {
                        this.getBySimulationIdSub$.next(result);
                    }
                })
            );
    }
}
